import { APIClient } from "./api_helper";

import * as url from "./url_helper";

const api = new APIClient();

// Authentication APIs
export const chatLogin = (data) => api.create(url.LOGIN, data);
export const forgotPassword = data => api.create(url.PASSWORD_FORGET, data);
export const ResetPassword = data => api.create(url.RESET_PASSWORD, data);

// Profile APIs
export const editUser = (data) => api.put(`${url.EDIT_USER}`, data);
export const fetchProfile = (data) => api.get(url.FETCH_PROFILE, data);

// Dashboard APIs
export const dashboardCount = (data) => api.get(url.dashboardCount, data);
export const dashboardAnalytics = (data) => api.get(url.dashboardAnalytics, data);

// User Management APIs
export const getAllUsers = (params) => api.get(url.GET_ALL_USERS, params);
export const getUserDetails = (userId) => api.get(`${url.GET_USER_DETAILS}/${userId}`);
export const bulkDeleteUsers = (data) => api.delete(url.BULK_DELETE_USERS, { data });
export const getUserHistory = (userId, params) => api.get(`${url.GET_USER_HISTORY}/${userId}/history`, params);
export const createAdminUser = (data) => api.create('/api/users/create', data);
export const updateUser = (id, data) => api.put(`${url.UPDATE_USER}/${id}`, data);

// Farmhouse APIs
export const getAllFarmhouses = (params) => api.get(url.GET_ALL_FARMHOUSES, params);
export const getFarmhouseDetails = (id) => api.get(`${url.FARMHOUSE}/${id}`);
export const createFarmhouse = (data) => api.create(url.FARMHOUSE, data);
export const updateFarmhouse = (id, data) => api.update(`${url.FARMHOUSE}/${id}`, data);
export const deleteFarmhouse = (id) => api.delete(`${url.FARMHOUSE}/${id}`);
export const updateFarmhouseStatus = (id, status) => api.update(`${url.FARMHOUSE}/${id}/status`, { status });
export const uploadFarmhouseImages = (id, data) => api.create(`${url.FARMHOUSE}/${id}/images`, data);
export const addFarmhouseAmenities = (id, data) => api.create(`${url.FARMHOUSE}/${id}/amenities`, data);
export const deleteFarmhouseAmenity = (farmId, amenityId) => api.delete(`${url.FARMHOUSE}/${farmId}/amenities/${amenityId}`);
export const deleteFarmhouseImage = (farmId, imageId) => api.delete(`${url.FARMHOUSE}/${farmId}/images/${imageId}`);
export const updateImagePriorities = (farmId, data) => api.put(`${url.FARMHOUSE}/${farmId}/images/priorities`, data);

// Booking APIs
export const createBooking = (data) => api.create(url.BOOKINGS, data);
export const getAdminBookings = (params) => api.get(url.ADMIN_GET_BOOKINGS, params);
export const getAdminBookingById = (id) => api.get(`${url.ADMIN_BOOKING}/${id}`);
export const deleteAdminBooking = (id) => api.delete(`${url.ADMIN_BOOKING}/${id}`);
export const getAvailableFarms = (params) => api.get(url.AVAILABLE_FARMS, params);
export const updateAdminBooking = (id, data) => api.update(`${url.ADMIN_BOOKING}/${id}`, data);
export const updatePaymentStatus = (id, data) => api.update(`${url.ADMIN_BOOKING}/${id}/payment-status`, data);
export const getFarmhouseBookingHistory = (farmhouseId) => api.get(`${url.FARMHOUSE_BOOKING_HISTORY}/${farmhouseId}/totelbookings`);
export const getFarmStatistics = (farmhouseId) => api.get(`${url.FARM_STATISTICS}/${farmhouseId}/statistics`);

// Static Pages APIs
export const getHouseRules = () => api.get(url.HOUSE_RULES);
export const updateHouseRules = (data) => api.create(url.HOUSE_RULES, data);

export const getPrivacyPolicy = () => api.get(url.PRIVACY_POLICY);
export const updatePrivacyPolicy = (data) => api.create(url.PRIVACY_POLICY, data);

export const getTermsAndConditions = () => api.get(url.TERMS_AND_CONDITIONS);
export const updateTermsAndConditions = (data) => api.create(url.TERMS_AND_CONDITIONS, data);

export const getCancellationPolicy = () => api.get(url.CANCELLATION_POLICY);
export const updateCancellationPolicy = (data) => api.create(url.CANCELLATION_POLICY, data);

// Settings APIs
export const getSettings = () => api.get(url.SETTINGS);
export const getLogo = () => api.get(url.GET_LOGO);
export const getDarkLogo = () => api.get(url.GET_DARK_LOGO);
export const getLoginImage = () => api.get(url.GET_LOGIN_IMAGE);
export const getHeroSliders = () => api.get(url.GET_HERO_SLIDERS);
export const updateSettings = (data) => api.put(url.SETTINGS, data);
export const uploadLogo = (data) => api.create(url.UPLOAD_LOGO, data);
export const uploadDarkLogo = (data) => api.create(url.UPLOAD_DARK_LOGO, data);
export const uploadLoginDialogImage = (data) => api.create(url.UPLOAD_LOGIN_DIALOG_IMAGE, data);
export const uploadHeroSliders = (data) => api.create(url.UPLOAD_HERO_SLIDERS, data);
export const deleteHeroSlider = (sliderId) => api.delete(`${url.DELETE_HERO_SLIDER}/${sliderId}`);
export const getHeroSliderById = (sliderId) => api.get(`${url.DELETE_HERO_SLIDER}/${sliderId}`);
export const createHeroSlider = (data) => api.create(url.UPLOAD_HERO_SLIDERS, data);
export const updateHeroSlider = (id, data) => api.put(`${url.DELETE_HERO_SLIDER}/${id}`, data);
export const getFarmhouseAmenities = (farmId) => api.get(`${url.FARMHOUSE}/${farmId}/amenities`);

// Locations APIs
export const getLocations = (params) => api.get(url.LOCATIONS, params);
export const createLocation = (data) => api.create(url.LOCATIONS, data);